import {
  GET_TASKS,
  GET_TASK_SUMMARY,
  TRANSITION_TASK,
  COMMENT_TASK,
  BULK_CLOSE_TASKS,
} from '../constants'
import { ITaskFilters } from '../services'

export function getTasks(
  size: number,
  page: number,
  filters: ITaskFilters,
  sort: { field: string; sort: string } | null,
  resolve: (value?: unknown) => void,
  reject: (reason?: unknown) => void,
) {
  return { type: GET_TASKS, size, page, filters, sort, resolve, reject }
}

export function getTaskSummary(
  resolve: (value?: unknown) => void,
  reject: (reason?: unknown) => void,
) {
  return { type: GET_TASK_SUMMARY, resolve, reject }
}

export function transitionTask(
  id: string,
  status: 'DONE' | 'REJECTED',
  comment: string | undefined,
  resolve: (value?: unknown) => void,
  reject: (reason?: unknown) => void,
) {
  return { type: TRANSITION_TASK, id, status, comment, resolve, reject }
}

export function commentTask(
  id: string,
  comment: string,
  resolve: (value?: unknown) => void,
  reject: (reason?: unknown) => void,
) {
  return { type: COMMENT_TASK, id, comment, resolve, reject }
}

export function bulkCloseTasks(
  ids: string[],
  resolve: (value?: unknown) => void,
  reject: (reason?: unknown) => void,
) {
  return { type: BULK_CLOSE_TASKS, ids, resolve, reject }
}
